var React = require('react');

function Magnifier (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.7 18.3l-5.4-5.4C15.4 11.5 16 9.8 16 8c0-4.4-3.6-8-8-8S0 3.6 0 8s3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l5.4 5.4c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4zM2 8c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6-6-2.7-6-6z"}));
}

Magnifier.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Magnifier;

Magnifier.default = Magnifier;
